import React, { useState, useEffect } from "react";
import Button from "components/button";
import { getRgba } from "helpers/get-rgba";

const StickyBar = ({ data }) => {

	const [showBar, setShowBar] = useState(false);

	const handleScroll = () => {
		const scrollPosition = window.scrollY;
		const totalPageHeight = document.body.scrollHeight - window.innerHeight;
		if (scrollPosition > totalPageHeight * (data?.scroll / 100)) {
			setShowBar(true);
		} else {
			setShowBar(false);
		}
	};

	useEffect(() => {
		window.addEventListener("scroll", handleScroll);
		return () => window.removeEventListener("scroll", handleScroll);
	}, []);

	return (
		showBar && (
			<div style={{ backgroundColor: getRgba(data?.bgColor) }} className="fixed md:block hidden bottom-0 w-full z-20">
				<div className="lg:w-4/5 w-full flex justify-between items-center m-auto py-4">
					<p>{data?.text}</p>
					<Button data={data?.button} className="md:mr-0"/>
				</div>
			</div>)
	);
};

export default StickyBar;